import { CognitoUserPool } from "amazon-cognito-identity-js";

// aws config
const userPool = {
  UserPoolId: "us-east-1_X8ZvlAfzE",
  ClientId: "1pf2nms2247fik73t0rsju4s9h",
};

const localUserPool = {
  UserPoolId: "us-east-1_X8ZvlAfzE",
  ClientId: "1pbv6oljkesrpmp9o7ti533u4",
};

// const cognitoUserPool = window.location.href.includes("localhost")
//   ? new CognitoUserPool(localUserPool)
//   : new CognitoUserPool(userPool);

// console.log(cognitoUser);

// export default cognitoUserPool;
export default new CognitoUserPool(userPool);
// export default new CognitoUserPool(localUserPool);
